export default __webpack_public_path__ + "static/media/Phone icon.1735f834.svg";